import React, { useState } from 'react';
import styles from './CourseCard.module.scss';
import Button from '../Button';
import classNames from 'classnames';
import { Icon } from 'Components';
import ToggleButton from '../ToggleButton';

interface Props {
	course: {
		id: number;
		title: string;
		tag?: string;
		image: string;
		courseCount?: string;
		isMandatory?: boolean;
		isSelected?: boolean;
	};
	index: number;
	htmlId?: string;
	onClick: () => void;
	onSelect?: (id: number) => void;
}

const RequiredSection = () => {
	const [isRequired, setIsRequired] = useState(true);

	const handleToggle = (e: React.MouseEvent) => {
		e.stopPropagation();
	};

	return (
		<div className={styles['required-section']} onClick={handleToggle}>
			<div className={styles.heading}>Required</div>
			<ToggleButton
				checked={isRequired}
				size="small"
				onChange={setIsRequired}
			/>
		</div>
	);
};

const CourseCard: React.FC<Props> = ({
	course,
	index,
	htmlId,
	onClick,
	onSelect
}) => {
	const handleDetailsClick = (e: React.MouseEvent) => {
		e.stopPropagation();
		onClick();
	};

	return (
		<div
			id={htmlId}
			className={classNames(styles['course-card'], {
				[styles['course-card--selected']]: course.isSelected
			})}
			onClick={
				onSelect && !course.isMandatory
					? () => onSelect(course.id)
					: () => null
			}
		>
			{course.isSelected && (
				<div className={styles.checked}>
					<Icon type="check" />
				</div>
			)}
			{course.isMandatory && (
				<div className={styles['card-cover']}>
					<span className={styles['message']}>
						This course is part of your selected learning path
					</span>
				</div>
			)}
			<div className={styles['image-wrapper']}>
				<img src={course.image} alt={course.title} />
				{course.courseCount ? (
					<div className={styles.courseCount}>
						{course.courseCount}
					</div>
				) : (
					<div className={styles.badge}>{index + 1}</div>
				)}
			</div>

			<div className={styles.content}>
				<div className={styles.title}>{course.title}</div>
				{course.tag && <span className={styles.tag}>{course.tag}</span>}
			</div>

			<Button fullWidth size="small" onClick={handleDetailsClick}>
				Details
			</Button>

			{course.isSelected && <RequiredSection />}
		</div>
	);
};

export default CourseCard;
